// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","container":"UploadMediaToChat_container__1603x"};